/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteIntervention (id: number) {
  return rest.delete(`/api/interventions/${id}`)
}

export function fetchIntervention (id: number): Promise<Intervention> {
  return rest.get(`/api/interventions/${id}`)
    .then((resp) => resp.json())
}

export function findTransactionsByIntervention (id: number, params?: Record<string, any>): Promise<HalDocument<{
  transactions: Transaction[]
}>> {
  return rest.get(`/api/interventions/${id}/transactions?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function fetchInterventionCount (params?: { status: InterventionStatus }): Promise<{
  count: number
}> {
  return rest.get(`/api/interventions/count?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyInterventions (params?: Record<string, any>): Promise<HalDocument<{
  interventions: Intervention[]
}>> {
  return rest.get(`/api/interventions?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyInterventionsAlerts (params?: Record<string, any>) {
  return rest.get(`/api/interventions/alerts?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchIntervention (id: number, data: Partial<Intervention>) {
  return rest.patch(`/api/interventions/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postIntervention (data: Partial<Intervention>) {
  return rest.post('/api/interventions', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
